import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'report',
  type: 'node--report',
  attributes: {
    title: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'title',
    },
    uuid: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'uuid',
    },
    pr_comercial: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'r_comercial',
    },
    pr_financiero: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'r_financiero',
    },
    pr_juridico: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'r_juridico',
    },
    pr_riesgos: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'r_riesgos',
    },
    pr_valoracionFinal: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'r_valoracion_final',
    },
  },
  relationships: {
  },
};

export const ReportService = createService(base, configuration, API_CONFIG.API);
export const ReportModule = createModule(ReportService, true);



// WEBPACK FOOTER //
// ./src/models/report.js